<template>
  <div class="share-container">
    <img v-lazy="image" class="share-img"/>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'

export default {
  mounted() {
    this.$nextTick(function () {
      this.load();
      this.image = 'https://cb.xhare.cn/qr?u=' + this.$route.query.u;
    })
  },
  data () {
    return {
      image: ""
    }
  },
  methods: {
    load() {
      let openid = sessionStorage.getItem("openid");
      if (openid) {
        this.getConfig(openid);
      } else {
        this.$http
          .get("https://cb.xhare.cn/openid", {
            params: { code: (window.location.search.substr(1).match(/(^|&)code=([^&]*)(&|$)/i)||[])[2] }
          })
          .then(
            function(res) {
              if (res.data.openid == "") {
                //this.redirect();
              } else {
                this.getConfig(res.data.openid);
                sessionStorage.setItem("openid", res.data.openid);
              }
            }.bind(this)
          )
          .catch(
            function() {
              //this.redirect();
            }.bind(this)
          );
      }
    },
    redirect() {
      window.location.href =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx1939c838a577589a&redirect_uri=https://m.xhare.cn/i/%23share%3Fu=" + this.$route.query.u + "&response_type=code&scope=snsapi_base&state=share";
    },
    // 微信分参数
    getConfig(openid) {
      let url = location.href.split('#')[0] //获取锚点之前的链接
      this.$http.get('https://cb.xhare.cn/jsconfig',{
        params: {
          url: url,
          openid: openid,
          u: this.$route.query.u
        }
      }).then(response => {
          let res = response.data.data;
          this.wxInit(res);
        })
    },
    // 微信分享
    wxInit(res) {
      let url = location.href.split('#')[0] //获取锚点之前的链接
      let links = url+'#/share?u=' + this.$route.query.u;
      let title = '【' + res.nickname + '】送你一个省钱神器';
      let desc = '我在XHARE省了好多，你也来试试？';
      let imgUrl = res.thumb;
      wx.config({
        debug: false,
        appId: res.appId,
        timestamp: res.timestamp,
        nonceStr: res.nonceStr,
        signature: res.signature,
        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone']
      });
      wx.ready(function() {
        let config = {
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: links, // 分享链接
          imgUrl: imgUrl, // 分享图标
          success: function() {
            //Toast({
              //message: "成功分享到朋友圈"
            //});
          },
          cancel: function() {
            //Toast({
              //message: "分享失败,您取消了分享!"
            //});
          }
        };
        wx.onMenuShareTimeline(config);
        wx.onMenuShareAppMessage(config);
        wx.onMenuShareQQ(config);
        wx.onMenuShareWeibo(config);
        wx.onMenuShareQZone(config);
      });
      wx.error(function(err) {
        alert(JSON.stringify(err))
      });
    }
  }
};
</script>

<style lang="less">
.share {
  &-img {
    width: 100%;
    height: auto;
  }
}
</style>
